import { uri } from 'utils';

const getFormattedPaginationLinkURLtest = (
    currentUrl,
    pageURLParameter,
    page
) => {
    // get URL as an object
    const urlObj = uri.parse(currentUrl);
    const commonURL = {
        hostname: urlObj.hostname,
        pathname: urlObj.pathname,
        port: urlObj.port,
        protocol: urlObj.protocol
    };
    // get current paramaters
    const query = uri.getParams(currentUrl);

    // construct new parameters
    let nextQuery = {
        ...query
    };

    // Do not generate link with ?page=1 as it would lead to duplicity
    // of content for SEO
    if (!page || page < 2) {
        nextQuery = Object.keys(nextQuery)
            .filter(key => key !== pageURLParameter)
            .reduce((acc, curr) => {
                return {
                    ...acc,
                    [curr]: nextQuery[curr]
                };
            }, {});
    }

    // set new page
    if (page && page > 1) {
        nextQuery = {
            ...query,
            [pageURLParameter]: page.toString()
        };
    }

    // return full URL
    return uri.format({
        ...commonURL,
        query: nextQuery
    });
};

export default getFormattedPaginationLinkURLtest;
